import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import { TSikutyosonListGetReq, TSikutyosonListGetRes } from "./TSikutyoson"

/**
 * 市区町村に対するAPIリクエスト用サービス
 *
 * @export
 * @class sikutyosonService
 * @extends {ConnectApi}
 */
export default class SikutyosonService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TSikutyosonListGetReq} params
   * @param {(param: TApiResponse<TSikutyosonListGetRes>) => any} resolve
   * @param {(param: TApiResponse<TSikutyosonListGetRes>) => any} reject
   * @memberof SikutyosonService
   */
  getList = async (params: TSikutyosonListGetReq, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<TSikutyosonListGetRes>> =
        await this.getInner(`/master/sikutyoson`, params, signal)
      return res.data
    } catch (err) {
      throw err
    }
  }
}
